import { Box, Tab, Tabs, useMediaQuery, alpha } from "@mui/material";
import { AccountCircle, Payment } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useSearchParams } from "react-router-dom";

const SECTIONS = [
  { icon: <AccountCircle />, label: "Profile", view: "profile" },
  { icon: <Payment />, label: "Billing", view: "billing" },
];

export default function PageTabs() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));

  const [params, setParams] = useSearchParams();
  const view = params.get("view") ?? "profile";
  const tab = SECTIONS.findIndex((s) => s.view === view);

  const handleTabChange = (_e, i) => setParams({ view: SECTIONS[i].view });

  return (
    <Tabs
      value={tab}
      onChange={handleTabChange}
      orientation={desktop ? "vertical" : "horizontal"}
      variant="fullWidth"
      aria-label="Account sections"
      // TabIndicatorProps={{ sx: { top: 0 } }}
      slotProps={{
        indicator: {
          sx: { top: 0, left: 0 },
        },
      }}
      sx={{
        position: "fixed",
        ...(desktop
          ? {
              left: 20,
              top: 80,
              maxHeight: "calc(100vh - 96px)",
              overflowY: "auto",
              width: 140,
            }
          : { bottom: 0, left: 0, right: 0 }),
        zIndex: 1000,
        bgcolor: alpha(theme.palette.background.paper, 0.95),
        pb: 2,
        "& .MuiTab-root": {
          minWidth: 70,
          minHeight: 70,
          justifyContent: desktop ? "flex-start" : "center",
          gap: 1,
        },
      }}
    >
      {SECTIONS.map(({ icon, label }) => (
        <Tab
          key={label}
          icon={icon}
          label={label}
          iconPosition="start"
          id={`tab-${label}`}
          aria-controls={`panel-${label}`}
        />
      ))}
    </Tabs>
  );
}
